module.exports = "/_next/static/images/nile_curry-7cb0a522da160535fa0193fe74871bcf.jpg";